const cn = {
   
    message: {
        title1: '远程控制智能家居，科技、安全又省心',
        content1:' AigoSmart助您能远程管理和控制家庭智能电器，设备之间也能彼此感知联动，一键触发即可使家庭各种电器进入您预设的状态，为您打造安全无忧的智能家庭生活。',
        title2:"AigoSmart为Aigostar全新子品牌",
        content2:"产品目前销往西班牙、葡萄牙、法国、意大利、荷兰、德国、芬兰、丹麦、波兰、俄罗斯、希腊、奥地利、瑞士、捷克、匈牙利、斯洛伐克等欧洲国家和地区。",
        content3:" AIGOSTAR多款厨房类、洗熨类小家电产品连续占据",
        content4:" 销量排行前十名。",
        title3:"品牌荣誉",
        content5:"快速 . 开放 . 创新 . 坚持",
        loading: '加载中',
        submit: '提交',
        contactUs:"联系我们",
        privacy:"隐私协议",
        policy:"服务政策",
        download:"下载",

    },
   
    
}

export default cn;